import {
  BoxV2 as Box,
  ButtonV2 as Button,
  Flex,
  TextInputV2 as TextInput,
} from 'portal-commons';
import { FunctionComponent, useState } from 'react';

import { FormLayout, FormSection, FormTitle } from './components';
import { brandController } from '@/apis/core';
import { toastFlashMessage } from '@/utils';

interface Authplus2faFormProps {
  brandUid: string;
  onCancel?: () => void;
  onSubmit?: () => void;
}

const Authplus2faForm: FunctionComponent<Authplus2faFormProps> = ({
  brandUid,
  onCancel,
  onSubmit,
}) => {
  const [proceeding, setProceeding] = useState(false);

  const handleSubmit = async () => {
    setProceeding(true);
    const response = await brandController.applyVetting(
      brandUid,
      'AUTHPLUS',
      'AEGIS'
    );
    setProceeding(false);
    if (response) {
      toastFlashMessage(
        'AUTHPLUS verification request submitted successfully',
        'success'
      );
      onSubmit?.();
    }
  };

  return (
    <FormLayout>
      <FormTitle
        title="Apply for New Verification"
        description={
          <Box>
            By submitting the Brand for external vetting you accept the{' '}
            <Box
              sx={{ color: 't.blue100' }}
              as="a"
              target="_blank"
              href="https://www.campaignregistry.com/TCR-T&Cs.pdf"
            >
              Terms & Conditions
            </Box>
          </Box>
        }
      />
      <Box sx={{ color: 't.black90', fontSize: 'H100' }}>
        * Indicates Required Field
      </Box>
      <FormSection>
        <TextInput
          readOnly
          label="Vetting Type"
          value="AUTHPLUS"
          data-testid="vettingClass"
        />
        <TextInput
          readOnly
          label="Vetting Partner"
          value="Aegis Mobile"
          data-testid="vettingProvider"
        />
        <Box
          sx={{
            gridColumn: 'span 2',
            color: 't.black90',
            fontWeight: 400,
            fontSize: 'H400',
            lineHeight: 'normal',
          }}
        >
          <Box sx={{ fontWeight: 600 }}>Estimated Time for Vetting:</Box>
          <Box>
            Time varies based on the vetting provider’s capacity and how quickly
            the brand’s business contact completes the email verification.
          </Box>
        </Box>
      </FormSection>
      <Flex sx={{ justifyContent: 'flex-end', gap: 'xl' }}>
        <Button
          size="lg"
          shape="square"
          variant="outline"
          color="secondary"
          disabled={proceeding}
          onClick={onCancel}
          data-testid="cancel"
        >
          Cancel
        </Button>
        <Button
          size="lg"
          shape="square"
          color="secondary"
          type="submit"
          disabled={proceeding}
          onClick={handleSubmit}
          data-testid="submit"
        >
          Submit
        </Button>
      </Flex>
    </FormLayout>
  );
};

export default Authplus2faForm;
